import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Route guard that protects authenticated application routes.
 * Allows navigation when the user is authenticated. If the user is
 * not authenticated, navigation is redirected to the sign-in page.
 * @param _route - Activated route information provided by Angular.
 * Not currently used by this guard.
 * @param _state - Router state information provided by Angular.
 * Not currently used by this guard.
 * @returns `true` when the user is authenticated; otherwise, an
 * Angular `UrlTree` that redirects the user to the sign-in page.
 */
export const authGuard: CanActivateFn = (_route, _state) => {
  /**
   * Provides access to the current authentication state.
   */
  const authService = inject(AuthService);

  /**
   * Provides Angular router functionality for creating the
   * redirect URL when authentication fails.
   */
  const router = inject(Router);

  return authService.isAuthenticated() || router.createUrlTree(['/signin']);
};